'use strict';

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

AlertStatusCache=class AlertStatusCache{
constructor(func){
this._func=func;
this._map=new Map;
}

get(notificationType){
_.ensureInstanceOf(NotificationType,notificationType);

let status=this._map.get(notificationType);

if(!_.exists(status)){
status=this._func(notificationType);
this._map.set(notificationType,status);
}

return status;
}

clear(){
this._map.clear();
}};


module.exports=AlertStatusCache;
//# sourceMappingURL=alertStatusCache.js.map
